import script from "./AboutMePage.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutMePage.vue?vue&type=script&setup=true&lang=js"

import "./AboutMePage.vue?vue&type=style&index=0&id=2875bd2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2875bd2e"]])

export default __exports__